export const facebookSignupEvent =(email) => {
    window.fbq('track','CompleteRegistration',{'email':email});
}

